import { CommonGet, CommonGetAxios, CommonPost } from './../../../helpers/HttpClient';
import { tokenDecoder } from 'src/utils/tokenDecoder';
import { getCachedLookup } from './../../../helpers/lookupCache';

export default {
    GetLedgerAccountDetailsByTransactionID
};

async function GetLedgerAccountDetailsByTransactionID(transactionTypeID, groupID, factoryID) {
    const cacheKey = `glAccounts:${parseInt(transactionTypeID)}:${parseInt(groupID)}:${parseInt(factoryID)}`;
    return getCachedLookup(cacheKey, async () => {
    const response = await CommonGet('/api/GLMapping/GetCreditDebitGLAccountsForTransation', "transactionTypeID=" + parseInt(transactionTypeID) + "&groupID=" + parseInt(groupID) + "&factoryID=" + parseInt(factoryID));
    return response;
    });
}
